import type { FC, ReactNode } from "react";
import * as ReactDOM from "react-dom";

interface PortalProps {
  children?: ReactNode;
  target?: HTMLElement | string;
}

export const Portal: FC<PortalProps> = ({
  children,
  target = document.body,
}) => {
  const container =
    typeof target === "string" ? document.querySelector(target) : target;

  if (!container) {
    // tslint:disable-next-line
    console.error(`Target element "${target}" is not in dom`);
    return <>{children}</>;
  }

  return ReactDOM.createPortal(children, container);
};
